/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Sort_AriaInputs */

const vi_customer_debt_sort_aria = /** @type {(inputs: Customer_Debt_Sort_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo nợ hiện tại`)
};

/**

* @param {Customer_Debt_Sort_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_sort_aria = /** @type {((inputs?: Customer_Debt_Sort_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Sort_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_sort_aria(inputs)
});